import { Autocomplete, Box, TextField } from '@mui/material';
import React from 'react';

import { W_NOTE_PROPERTIES } from '../../extensions';
import { CommandForm, ICommandFormProps } from './CommandForm';

export interface ToggleWNoteFormProps extends Omit<ICommandFormProps, 'children' | 'fields'> {
  initialOption?: string;
  initialValues?: any;
  onRemove?: () => void;
}

export const ToggleWNoteForm = (props: ToggleWNoteFormProps) => {
  const { ...rest } = props;

  return (
    <CommandForm name="wNote" {...rest}>
      <Autocomplete
        id="type"
        size="small"
        options={W_NOTE_PROPERTIES.typeList}
        autoHighlight
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option: any) => option}
        renderOption={(props, option) => {
          props['data-name'] = 'type';
          return (
            <Box component="li" {...props}>
              {option}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name="type"
            label="Type"
            size="small"
            variant="standard"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
          />
        )}
      />
    </CommandForm>
  );
};
